import React, { useEffect, useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ExternalLink, ShoppingBag } from "lucide-react";
import api from "@/lib/api";

export const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/payments/orders").then((r) => setOrders(r.data || [])); }, []);
  return (
    <div className="space-y-6" data-testid="orders-page">
      <div>
        <h1 className="font-display text-3xl font-bold">My Orders</h1>
        <p className="text-[#8a8a8a] text-sm mt-1">All challenge purchases and their status.</p>
      </div>
      <div className="glass rounded-xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[10px] tracking-widest text-[#8a8a8a] uppercase border-b border-[#ff7a00]/15">
              <th className="text-left p-4">Date</th>
              <th className="text-left p-4">Challenge</th>
              <th className="text-right p-4">Account Size</th>
              <th className="text-right p-4">Paid</th>
              <th className="text-left p-4">Payment</th>
              <th className="text-left p-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-[#8a8a8a]"><ShoppingBag className="mx-auto text-[#ff7a00] mb-3" size={28} />No orders yet.</td></tr>
            )}
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-[#ff7a00]/5 hover:bg-white/2" data-testid={`order-row-${o.id}`}>
                <td className="p-4 text-[#cfcfcf]">{new Date(o.created_at).toLocaleDateString()}</td>
                <td className="p-4 text-[#f5f5f5]">{o.challenge_name}</td>
                <td className="p-4 text-right text-[#cfcfcf]">${o.account_size.toLocaleString()}</td>
                <td className="p-4 text-right font-display font-bold text-[#ff7a00]">${o.price_amount}</td>
                <td className="p-4 text-[#cfcfcf]">{(o.pay_currency || "—").toUpperCase()}</td>
                <td className="p-4">
                  <Badge className={`uppercase text-[10px] tracking-widest ${
                    o.status === "paid" || o.status === "assigned" ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" :
                    o.status === "pending" ? "bg-[#ff7a00]/15 text-[#ff9a2f] border-[#ff7a00]/30" :
                    "bg-red-500/15 text-red-400 border-red-500/30"
                  }`}>{o.status}</Badge>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
